import { FC, MouseEvent } from 'react'
import { Grid } from '@mui/material'

import { AutocompleteOption, CommandParametersType } from '@types'

import { ParameterListItem } from '../ParameterListItem'

type ParameterListType = {
  canChangeRefObject: boolean
  defaultFieldsObjectOption: AutocompleteOption<string> | null
  refObjectOptions?: AutocompleteOption[]
  commandParameterOptions: AutocompleteOption[]
  isLoadingCommandParameters: boolean
  list: CommandParametersType[]
  editItemIndex: number | null
  onShowScriptValueDialog: () => void
  onSetCurrentNameScriptDialog: (value: 'value' | `parameters.${number}.value` | null) => void
  onChangeType: (type: AutocompleteOption, index: number) => void
  onChangeObjectCode: (type: AutocompleteOption<string>, index: number) => void
  onClear: (event: MouseEvent<HTMLButtonElement>, index: number) => void
  onDelete: (index: number) => void
  onEdit: (index: number | null) => void
  onUpdate: (index: number) => void
}

export const ParameterList: FC<ParameterListType> = ({
  defaultFieldsObjectOption,
  commandParameterOptions,
  refObjectOptions,
  canChangeRefObject,
  isLoadingCommandParameters,
  editItemIndex,
  list = [],
  onShowScriptValueDialog,
  onSetCurrentNameScriptDialog,
  onChangeType,
  onChangeObjectCode,
  onClear,
  onDelete,
  onEdit,
  onUpdate,
}) => {
  if (!list.length) {
    return null
  }

  return (
    <Grid
      container
      sx={{
        maxHeight: 200,
        scrollbarGutter: 'stable',
        overflow: 'auto',
        border: theme => theme.palette.border.customTable,
      }}
    >
      {list.map((parameter, index: number) => (
        <ParameterListItem
          key={`parameter_${parameter.title}`}
          canChangeRefObject={canChangeRefObject}
          commandParameterOptions={commandParameterOptions}
          defaultFieldsObjectOption={defaultFieldsObjectOption}
          editItemIndex={editItemIndex}
          isLoadingCommandParameters={isLoadingCommandParameters}
          item={parameter}
          itemIndex={index}
          refObjectOptions={refObjectOptions}
          onChangeObjectCode={onChangeObjectCode}
          onChangeType={onChangeType}
          onClear={onClear}
          onDelete={onDelete}
          onEdit={onEdit}
          onSave={onUpdate}
          onSetCurrentNameScriptDialog={onSetCurrentNameScriptDialog}
          onShowScriptValueDialog={onShowScriptValueDialog}
        />
      ))}
    </Grid>
  )
}
